<template>
  <div>
    <div class="edit-view" v-no-capture>
      <ck-editor
        ref="editor"
        :config="ckeditorConfig"
        :initial-data="initialData"
        :id="'editor-' + uuid"
        @change="$emit('change', $event)"
        @save="$emit('save', $event)"
      />
      <div class="field-error-message" v-if="error">
        {{ error }}
      </div>
      <submit-buttons
        class="mt-3"
        submit-text="Save"
        :is-loading="isSaving"
        @save="$emit('save', $refs.editor.getData())"
        @cancel="$emit('cancel')"
      >
        <slot />
      </submit-buttons>
    </div>
  </div>
</template>

<script>
import { getCKEditorConfig } from '@/ckeditorConfig'
import CkEditor from '@/components/CkEditor.vue'
import SubmitButtons from '@/components/SubmitButtons.vue'
import ComponentIdMixin from '@/mixins/ComponentIdMixin'

/**
 * This is a simple form containing CKEditor and submit buttons.
 */
export default {
  name: 'CkEditorForm',
  components: { SubmitButtons, CkEditor },
  props: ['error', 'mentionableUsers', 'orgId', 'initialData', 'ckeConfig', 'isSaving'],
  mixins: [ComponentIdMixin],
  computed: {
    ckeditorConfig() {
      return {
        ...getCKEditorConfig({
          height: 300,
          startupFocus: true,
          users: this.mentionableUsers,
          orgId: this.orgId
        }),
        ...this.ckeConfig
      }
    }
  },
  methods: {}
}
</script>

<style scoped lang="scss">
@import '~@/styles/_errors.scss';
@import '~@/styles/_styleConfigurations.scss';

.edit-view {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.field-error-message {
  padding-left: 8px;
  padding-top: 8px;
  font-size: $fontSizeM;
}
</style>
